import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { createInvoicesTemplatePreview } from 'src/shared/services/invoiceService';
import { CreateInvoiceTemplatePreviewRequest } from '../models/createInvoiceTemplatePreviewRequest';

type PreviewInvoiceTemplateDownloaderProps = {
  dataToPdf: CreateInvoiceTemplatePreviewRequest;
  loadingCallback: (isLoading: boolean) => void;
};

export const PreviewInvoiceTemplateDownloader = async (props: PreviewInvoiceTemplateDownloaderProps) => {
  const { dataToPdf, loadingCallback } = props;

  try {
    loadingCallback(true);

    const result = await createInvoicesTemplatePreview(dataToPdf.templateSendingsId);
    if (result.data) {
      const blob = new Blob([new Uint8Array(result.data)], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `faktura_${dataToPdf.templateSendingsId}.pdf`;
      a.click();
      a.remove();
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 100);
    }
  } catch (e) {
    ConsoleHelper.log(e);
  } finally {
    loadingCallback(false);
  }
};
